import { EnumValues } from '@cbgms/api/modules/enums'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { GETResponse } from '@cbgms/api'

type GETEnumResponse = GETResponse<EnumValues>

export const loadEnums = () =>
  AsyncAction<GETEnumResponse>({
    type: [types.LOAD_ENUMS, types.LOAD_ENUMS_SUCCESS, types.LOAD_ENUMS_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'GET',
        url: '/miscellaneous/enumtypes'
      }
    }
  })
